import { fetcher } from "helpers/fetcher";

import { TGetTicketDetailsReq, TGetTicketDetailsRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export enum ETicketDetailScope {
  TICKET_DETAIL = "TICKET_DETAIL",
  ATTACHMENTS = "ATTACHMENTS",
}

export const getTicketDetails = async (payload: TGetTicketDetailsReq) => {
  return await fetcher<TGetTicketDetailsRes, any>(
    ENDPOINT.MANAGEMENT.GET_TICKET_DETAIL,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.MANAGEMENT.GET_TICKET_DETAIL.version,
        [API_HEADER.BU_ID]: payload.idBu,
      },
      urlData: {
        pipelineSlug: payload.pipelineSlug,
        idTicket: payload.idTicket,
      },
    }
  );
};

export const queryGetTicketDetails = async (payload: TGetTicketDetailsReq) => {
  return (await getTicketDetails(payload)).data;
};

queryGetTicketDetails._key = (
  payload: TGetTicketDetailsReq,
  dataType: ETicketDetailScope
) => [ENDPOINT.MANAGEMENT.GET_TICKET_DETAIL.url, payload, dataType];
